import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Card, Empty } from "@/components/ui/page";
import { Pill } from "@/components/StatusBadge";
import { fmtDuration, fmtTime } from "@/lib/format";

export default function Exceptions() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/reports/exceptions").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader title="Break Exceptions" subtitle="Employees who exceeded their break allowances" testId="exceptions-header" />
      <Card testId="exceptions-table">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50"><tr className="text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
              <th className="px-4 py-3">Employee</th><th className="px-4 py-3">Process</th><th className="px-4 py-3">Break</th>
              <th className="px-4 py-3">Allowed</th><th className="px-4 py-3">Used</th><th className="px-4 py-3">Exceeded</th>
              <th className="px-4 py-3">Date</th><th className="px-4 py-3">Status</th></tr></thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={8}><Empty label="No exceptions 🎉" /></td></tr>}
              {rows.map((r) => (
                <tr key={r.id} data-testid={`exc-row-${r.id}`} className="border-t border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-3 font-semibold text-[#0B1F33]">{r.employee_name} <span className="text-xs text-slate-400">{r.employee_id}</span></td>
                  <td className="px-4 py-3 text-slate-600">{r.process}</td>
                  <td className="px-4 py-3">{r.break_label}</td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-400">{fmtDuration(r.allowed_seconds)}</td>
                  <td className="px-4 py-3 font-mono text-xs">{fmtDuration(r.duration_seconds)}</td>
                  <td className="px-4 py-3 font-mono text-xs font-bold text-red-600">+{fmtDuration(r.exceeded_seconds)}</td>
                  <td className="px-4 py-3 text-xs text-slate-500">{r.date}</td>
                  <td className="px-4 py-3"><Pill tone="red">EXCESS BREAK</Pill></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
